var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "数据权限管理",
        visible: _vm.powerVisible,
        width: "500px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.powerVisible = $event
        }
      }
    },
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            border: "",
            height: "400px",
            size: "mini",
            data: _vm.rights,
            "highlight-current-row": "",
            "expand-on-click-node": "false"
          }
        },
        [
          _c("el-table-column", { attrs: { type: "index" } }),
          _c("el-table-column", {
            attrs: {
              label: "乡镇或街道",
              prop: "regionName",
              "min-width": "100",
              align: "left"
            }
          }),
          _c("el-table-column", {
            attrs: { label: "授权访问", width: "150", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-switch", {
                      on: {
                        change: function($event) {
                          return _vm.rightChange(scope.row)
                        }
                      },
                      model: {
                        value: scope.row.enabled,
                        callback: function($$v) {
                          _vm.$set(scope.row, "enabled", $$v)
                        },
                        expression: "scope.row.enabled"
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.powerVisible = false
                }
              }
            },
            [_vm._v("关闭")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }